/**
 * Mirrors backend/src/lib/companySignIn.ts: plain company addresses sign in
 * with the company account; plus addresses (name+tag@) keep the password path.
 */
export const COMPANY_EMAIL_DOMAIN = "media4care.de";
export const COMPANY_SIGN_IN_REQUIRED_ERROR = "company-sign-in-required";
export const COMPANY_SIGN_IN_UNAVAILABLE_ERROR = "company-sign-in-unavailable";

export const requiresCompanySignIn = (email: string): boolean => {
  const normalized = email.trim().toLowerCase();
  const at = normalized.lastIndexOf("@");
  if (at <= 0 || at === normalized.length - 1) return false;
  return normalized.slice(at + 1) === COMPANY_EMAIL_DOMAIN && !normalized.slice(0, at).includes("+");
};
